var map = {
	"./history/common/historyDataBg.png": "Xir0",
	"./theme1/common/historyDataBg.png": "NFZ+"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "WgDe";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\/common\/historyDataBg\.png$
// module id = WgDe
// module chunks = 319